import React from 'react';

const TimeStamp = ({timeValue, direction}) => {
    return (
        <div className={`timeStampWrapper ${direction}`}>
            <div className="timeStamp">
                { timeValue }
                <div className="corner topLeft"></div>
                <div className="corner topRight"></div>
                <div className="corner bottomLeft"></div>
                <div className="corner bottomRight"></div>
            </div>
        </div>
    )
}

export default TimeStamp;



// WEBPACK FOOTER //
// ./src/components/modules/HomeHero/TimeStamp.js